import React from 'react';
import { useTranslation } from 'react-i18next';
import Carousel from 'react-multi-carousel';
import { Row, Col, Button, Container } from 'react-bootstrap';

import { facebookReviewsData, responsive } from '../../utils/constants';
import { Hero, PageContainer } from '../../components';
import './ReviewPage.scss';

function ReviewPage() {
  const { t } = useTranslation();

  function displayFacebookReviews() {
    return facebookReviewsData.map((item, index) => (
      <div className='reviews-grid' key={index}>
        <Container className="review-card">
          <div className="stars">
            {'★'.repeat(item.rating)}
            {'☆'.repeat(5 - item.rating)}
          </div>
          <p>"{item.message}"</p>
          <br/>
          <p className="review-author"><strong>{item.author}</strong></p>
        </Container>
      </div>
    ));
  }

  return (
    <div className='main-content'>
      <Hero className='review-hero'>
        <h1>{t('REVIEW_TITLE')}</h1>
        <p>{t('REVIEW_INTRO')}</p>
      </Hero>
      <PageContainer>
        <Row className='justify-content-md-center reviews-section'>
          <h2>{t('REVIEW_TEXT')}</h2>
          <Col md={10}>
            <Carousel
              responsive={responsive}
              autoPlay={true}
              swipeable={true}
              draggable={true}
              showDots={true}
              infinite={true}
              partialVisible={false}
              arrows={false}
              autoPlaySpeed={3000}
              dotListClass='custom-dot-list-style'
            >
              {displayFacebookReviews()}
            </Carousel>
          </Col>
        </Row>
        <Container className="text-center py-4 bg-white shadow-sm">
        </Container>
        <Container className="highlights">
          <Row className="justify-content-md-center">
            <Col xs={12} md={5} className="py-4">
              <h2>{t('HIGHLIGHTS_TITLE')}</h2>
              <ul>
                <li>{t('HIGHLIGHT_1')}</li>
                <li>{t('HIGHLIGHT_2')}</li>
                <li>{t('HIGHLIGHT_3')}</li>
              </ul>
            </Col>
            <Col xs={12} md={5} className="text-center py-4">
              <h3>{t('REVIEW_HAVE_YOU')}</h3>
              <p>{t('REVIEW_LET_OTHER')}</p>
              <Button className="btn-dark" size="lg" href="https://www.facebook.com/profile.php?id=61558330046817" target="_blank">
                {t('REVIEW_LEAVE_REVIEW')}
              </Button>
            </Col>
          </Row>
        </Container>
      </PageContainer>
    </div>
  )
};

export default ReviewPage;